<!--
 * @Author: RYL
 * @Description: 权限分配
 * @Date: 2020-12-24 17:30:37
 * @LastEditTime: 2020-12-25 18:11:49
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog
      :title="$t('lang.Authoritymanagement.mandatory')"
      :visible.sync="dialogVisible"
      width="30%"
      center>
      <el-tabs v-model="roleType">
        <el-tab-pane :label="$t('lang.Authoritymanagement.deviceManagement')" name="device">
          <!--      权限树形列表-->
          <div style="height: 30vh;overflow-y: scroll;" v-loading="loading">
            <el-tree
              :data="TreeData"
              show-checkbox
              node-key="functionId"
              ref="SetTree"
              highlight-current
              render-after-expand
              :props="defaultProps">
            </el-tree>
          </div>
        </el-tab-pane>
        <el-tab-pane label="云监测" name="monitor" v-if="monState == 1">
          <div style="height: 30vh;overflow-y: scroll;" v-loading="loading">
            <el-tree
              :data="monitorList"
              show-checkbox
              node-key="functionId"
              ref="monitorTree"
              highlight-current
              render-after-expand
              :props="defaultProps">
            </el-tree>
          </div>
        </el-tab-pane>
      </el-tabs>
        <span slot="footer" class="dialog-footer">
        <el-button
          @click="dialogVisible = false"
          size="mini"
          style="margin-bottom: 0.2rem">
          {{$t('lang.Authoritymanagement.cancel')}}
        </el-button>
        <el-button
          type="primary"
          @click="ModifyRole"
          size="mini"
          style="margin-bottom: 0.2rem">
          {{$t('lang.Authoritymanagement.Determine')}}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getFunctionalAuthority,
  showFunctionList,
  getRoleOwnFunction,
  modifyRoleFunction,
  deleteRole,
  addRole,
  modifyRoleNameAndDescription,
  queryKeyword
} from "@/api/Authoritymanagement";
import { cloneDeep, isEqual } from 'lodash'
import { GetMonitor } from '@/localStorage/localStorage'
export default {
  data() {
    return {
      dialogVisible: false,
      TreeData: [],
      monitorList: [], // 云监测菜单
      setuser: {},
      loading: false,
      //权限树形控件显示字段
      defaultProps: {
        children: 'functionList',
        label: 'functionName'
      },
      roleType: 'device', 
      monState: 0, // 是否开通云监测功能
    }
  },
  methods: {
    clearData() {
      this.roleType = 'device'
      this.TreeData = [],
      this.monitorList = [], // 云监测菜单
      this.setuser = {}
    },
    show(row) {
      this.clearData()
      this.dialogVisible = true
      this.monState = GetMonitor()
      const {roleName,roleDescription,roleId}=row
      this.setuser={roleName,roleDescription,roleId}
      this.fetchDeviceRole()
      if(this.monState == 1) {
        this.fetchMonitorRole()
      } 
    },
    // 获取设备管理权限
    fetchDeviceRole() {
      this.loading = true
      //获取最新的权限列表
      showFunctionList(this.$i18n.locale == "en-US" ? 1 : 0, 0).then(res => {
        this.TreeData = res.data.queryResult;
      });
      //使用async await发生未知错误,故使用setTimeout 0将请求放在任务队列末端
      setTimeout(()=>{
        getRoleOwnFunction(this.setuser.roleId, 0).then((res)=>{
          //获取到roleFunctionFunctionid,添加选中
          let keys=[]
          // 筛选选中
          res.data.queryResult.map((val)=>{
            if(val.nctRoleFuns.length>0){
              val.nctRoleFuns.forEach((Item)=>{
                if(Item.nctRoleFuns.length>0){
                  Item.nctRoleFuns.forEach((Items)=>{
                    keys.push(Items.roleFunctionFunctionid)
                  })
                }else {
                  keys.push(Item.roleFunctionFunctionid)
                }
              })
            }
          })
          this.$refs.SetTree.setCheckedKeys(keys)
          this.loading = false
        })
      },0)
    },
    // 获取云监测权限
    fetchMonitorRole() {
      this.loading = true
      //获取最新的权限列表
      showFunctionList(this.$i18n.locale == "en-US" ? 1 : 0, 1).then(res => {
        this.monitorList = res.data.queryResult;
      });
      //使用async await发生未知错误,故使用setTimeout 0将请求放在任务队列末端
      setTimeout(()=>{
        getRoleOwnFunction(this.setuser.roleId, 1).then((res)=>{
          //获取到roleFunctionFunctionid,添加选中
          let keys=[]
          // 筛选选中
          res.data.queryResult.map((val)=>{
            if(val.nctRoleFuns.length>0){
              val.nctRoleFuns.forEach((Item)=>{
                if(Item.nctRoleFuns.length>0){
                  Item.nctRoleFuns.forEach((Items)=>{
                    keys.push(Items.roleFunctionFunctionid)
                  })
                }else {
                  keys.push(Item.roleFunctionFunctionid)
                }
              })
            }
          })
          this.$refs.monitorTree.setCheckedKeys(keys)
          this.loading = false
        })
      },0)
    },
    //修改权限
    ModifyRole() {
      let deviceRole = this.$refs.SetTree.getCheckedNodes(false,true).map(val=>val.functionId)
      let finalRole = []
      if(this.monState == 1) {
        let monitorRole = this.$refs.monitorTree.getCheckedNodes(false,true).map(val=>val.functionId)
        finalRole = deviceRole.concat(monitorRole)
      }else{
         finalRole = deviceRole
      }
      // let monitorRole = this.$refs.monitorTree.getCheckedNodes(false,true).map(val=>val.functionId)
      // 修改设备管理权限
      modifyRoleFunction(this.setuser.roleId,finalRole).then(res => {
        if (res.data.code === 0) {
           this.$message({
            message: this.$t("lang.Authoritymanagement.m_pr_modifyS"),
            type: "success"
        });
        } else {
          this.$message({
          message: this.$t("lang.Authoritymanagement.onCallModifying"),
          type: "warning"
        });
        }
      });
      this.dialogVisible = !this.dialogVisible;
    },
  }
}
</script>